import { Box, Typography, Grid, Tooltip, LinearProgress, IconButton } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import FileTypeIcon from './FileTypeIcon';

const FileListCard = (props) => {
    const { file, handleDeleteFile, selected, onSelect } = props;
    const { t } = useTranslation();
    const [fileName, setFileName] = useState('');

    useEffect(() => {
        if (file?.qubFile?.name?.length > 20) {
            setFileName(`${file?.qubFile?.name.substring(0, 17)}...`);
        } else {
            setFileName(file?.qubFile?.name);
        }
    }, [file]);

    const handleSelectFile = () => {
        if (onSelect && typeof onSelect === 'function') onSelect(file?.id);
    };

    return (
        <Box
            sx={{
                p: 1,
                border: 1,
                borderColor: '#4d79bc',
                borderRadius: 2,
                background: selected ? '#ffd35e' : '#fff',
                ':hover': { border: 2, borderColor: '#4d79bc' }
            }}
            onClick={handleSelectFile}
        >
            <Grid container spacing={2} justifyContent="space-between">
                <Grid item container xs={2} alignItems="center">
                    <FileTypeIcon file={file?.qubFile} />
                </Grid>
                <Grid item container alignItems="center" xs={7}>
                    {file?.qubFile?.name && file?.qubFile?.name.length > 20 ? (
                        <Tooltip title={file?.qubFile?.name}>
                            <Typography variant="body1">{fileName}</Typography>
                        </Tooltip>
                    ) : (
                        <Typography variant="body1">{fileName}</Typography>
                    )}
                </Grid>
                <Grid item container xs={2} alignItems="center">
                    <Tooltip title={t('Delete')}>
                        <IconButton
                            sx={{ color: '#c42c0e' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteFile({ id: file?.id, qubId: file?.qubFile?.id });
                            }}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
        </Box>
    );
};

export default FileListCard;
